import qs from 'query-string';

/**
 * `getQSParams()` avoids some bugs that the `param()` util has.
 * It also fully types its return value.
 * @param params url parameters.
 */

const getQSParams = <Param extends string>(
  ...params: ReadonlyArray<Param>
): Record<Param, Exclude<qs.ParsedQuery[string], string[]>> => {
  const query = qs.parse(window.location.search);
  return params.reduce(
    (result, param) => {
      const value = query[param];
      // The "array" here is not referring to an array value, but rather to multiple occurrences of a param in the query string.
      // Only use the first occurrence when there are multiple.
      result[param] = Array.isArray(value) ? value[0] : value;
      return result;
    },
    {} as Record<Param, Exclude<qs.ParsedQuery[string], string[]>>,
  );
};

export default getQSParams;
